// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oBiLH","heading":"styles_heading__-lntj"};